import { SET_THEME_DARK, SET_THEME_LIGHT, TOGGLE } from "../actions/types";

const initialState = {
    theme: "light",
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_THEME_DARK:
            return {
                ...state,
                theme: "dark",
            };

        case SET_THEME_LIGHT:
            return {
                ...state,
                theme: "light",
            };
        case TOGGLE:
            return {
                ...state,
                theme: state.theme == "dark" ? "light" : "dark",
            };

        default:
            return state;
    }
}
